import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { fetchMiscs } from "../../store/slices/miscsSlice";
import Loader from "../../components/base-components/Loader";
import ErrorMessage from "../../components/base-components/Error";
import { useInView } from "react-intersection-observer";

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

const Footer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { miscs, status, error } = useSelector(
    (state: RootState) => state.miscs
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchMiscs());
    }
  }, [dispatch, status]);

  const { ref, inView } = useInView({ threshold: 0.1 });

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <ErrorMessage message={error} />;
  }

  const footerSlogan =
    miscs.find((misc) => misc.attributes.title === "footer_slogan")?.attributes
      .value || "Loading footer slogan...";

  return (
    <motion.footer
      ref={ref}
      className="bg-[#182642] py-[7rem]"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={containerVariants}
      transition={{ duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }}
    >
      <motion.div
        className="global-container flex flex-col md:flex-row gap-x-[4.5rem] justify-between"
        variants={containerVariants}
        transition={{ staggerChildren: 0.2 }}
      >
        <motion.div
          className="flex max-w-[47rem] mb-[4rem] md:mb-0"
          variants={itemVariants}
        >
          <img
            className="h-[6.5rem] mr-[2.4rem]"
            src="/images/dancap-logo.png"
            alt="logo"
          />
          <p className="text-white text-[1.6rem]">{footerSlogan}</p>
        </motion.div>

        <motion.div
          className="flex flex-col text-white gap-y-[1.2rem] w-[18.5rem] mb-[4rem] md:mb-0"
          variants={itemVariants}
        >
          <p className="text-[1.6rem] font-semibold">Links</p>
          <Link className="text-[1.6rem] hover:underline" to="/about">
            About Us
          </Link>
          <Link className="text-[1.6rem] hover:underline" to="/developments">
            Developments
          </Link>
          {/* <Link className="text-[1.6rem] hover:underline" to="/ventures">
            Ventures
          </Link> */}
          <Link className="text-[1.6rem] hover:underline" to="/contact">
            Contact Us
          </Link>
        </motion.div>

        <motion.div
          className="flex flex-col text-white gap-y-[1.2rem] w-[18.5rem] mb-[4rem] md:mb-0"
          variants={itemVariants}
        >
          <p className="text-[1.6rem] font-semibold">Legal</p>
          <Link className="text-[1.6rem] hover:underline" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link
            className="text-[1.6rem] hover:underline"
            to="/terms-of-service"
          >
            Terms of Service
          </Link>
        </motion.div>

        {/* <motion.div
          className="flex flex-col text-white w-[18.5rem] gap-y-[1.2rem]"
          variants={itemVariants}
        >
          <p className="text-[1.6rem] font-semibold">Connect With Us</p>
          <a className="flex text-[1.6rem] hover:underline" href="#">
            <img
              src="/icons/Facebook.svg"
              alt="facebook"
              className="w-[2.4rem] h-[2.4rem] mr-[1.2rem]"
            />
            Facebook
          </a>
          <a className="flex text-[1.6rem] hover:underline" href="#">
            <img
              src="/icons/Instagram.svg"
              alt="instagram"
              className="w-[2.4rem] h-[2.4rem] mr-[1.2rem]"
            />
            Instagram
          </a>
          <a className="flex text-[1.6rem] hover:underline" href="#">
            <img
              src="/icons/LinkedIn.svg"
              alt="linkedin"
              className="w-[2.4rem] h-[2.4rem] mr-[1.2rem]"
            />
            LinkedIn
          </a>
          <a className="flex text-[1.6rem] hover:underline" href="#">
            <img
              src="/icons/Twitter-X.svg"
              alt="twitter"
              className="w-[2.4rem] h-[2.4rem] mr-[1.2rem]"
            />
            Twitter / X
          </a>
        </motion.div> */}
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
